export default {
  root: ({ props, context, parent, instance }) => {
    const site = useSiteStore();
    return {
      class: [
        'w-full',
        // Font
        'leading-none',

        // Flex
        { 'flex-1 w-[1%]': parent.instance.$name === 'InputGroup' },

        // Spacing
        'm-0',
        {
          'py-4 px-3.5': props.size === 'large',
          'py-1.5 px-2': props.size === 'small',
          'py-3 px-3': props.size === null,
          '!pt-5 !pb-2':
            props.size === null && parent.instance?.$name === 'FloatLabel',
          'pl-16':
            (parent.instance?.$name === 'FloatLabel' &&
              instance?.$attrs?.type === 'tel' &&
              site.getRegion === 'ZA') ||
            !!parent?.instance?.$attrs?.['data-prefix'],
          'pl-20':
            parent.instance?.$name === 'FloatLabel' &&
            instance?.$attrs?.type === 'tel' &&
            site.getRegion !== 'ZA',
          '!py-3':
            !instance?.$data.d_value && parent.instance?.$name === 'FloatLabel',
        },

        // Shape
        { 'rounded-lg': parent.instance.$name !== 'InputGroup' },
        {
          'first:rounded-l-md rounded-none last:rounded-r-md':
            parent.instance.$name === 'InputGroup',
        },
        {
          'border-0 border-y border-l last:border-r':
            parent.instance.$name === 'InputGroup',
        },
        {
          'first:ml-0 -ml-px':
            parent.instance.$name === 'InputGroup' && !props.showButtons,
        },

        // Colors
        'text-base-priority bg-base',
        'autofill:!bg-stacked',
        { 'input-style': !context.disabled },
        'border',
        { 'stacked-border': !props.invalid },
        // Invalid State
        {
          'invalid:focus:border-error-500 dark:invalid:focus:border-error-500':
            !!context.filled,
        },
        {
          '!text-dark-800/30 dark:!text-light-700/40 std-border cursor-not-allowed':
            !!context.disabled,
        },
        { 'border-error-500 dark:border-error-500': props.invalid },
        // States
        {
          'focus:outline-none focus:outline-offset-0  focus:border-primary-blue-500 dark:focus:border-primary-blue-400 focus:z-10':
            !context.disabled && !props.invalid,
        },
        'focus:outline-none focus:outline-offset-0 focus:z-10',

        // Filled State *for FloatLabel
        {
          filled:
            parent.instance?.$name === 'FloatLabel' &&
            (props.modelValue || instance?.$attrs?.touched),
        },

        // Misc
        'appearance-none',
        'transition-colors duration-200',
        // 'bg-clip-content',
      ],
    };
  },
};
